import { useAuth } from '../contexts/AuthContext'
import './BetaGlobalBanner.css'

/** Bandeau discret : beta active + accès limité (invité ou élève non whitelisté). */
export default function BetaGlobalBanner() {
  const { betaPrivateActive, hasFullCloudAccess, isGuest, user } = useAuth()

  if (!betaPrivateActive) return null
  if (hasFullCloudAccess && !(isGuest && !user)) return null

  const isDemoGuest = isGuest && !user
  const notSignedIn = !user
  return (
    <div className="beta-global-banner" role="status">
      <span className="beta-global-banner-dot" aria-hidden />
      <span>
        {notSignedIn
          ? 'Beta privée — connectez-vous (Google ou e-mail) pour accéder à votre espace.'
          : isDemoGuest
            ? 'Beta privée — mode démo (données locales, pas de synchro cloud).'
            : 'Beta privée — accès limité aux contenus vitrine (compte connecté).'}
      </span>
    </div>
  )
}
